export const TOOL_TASK = 'assign-product-seat';
export const TOOL_TITLE = 'Assign Product Seat';
export const TOOL_PROGRESS_LABEL = 'Product seat assignment progress...';
export const TOOL_STACK_OVERFLOW_MESSAGE = 'Please try again once product seat assignment finishes';
export const FILE_NAME = 'Assign-product-seat-report';
export const FILE_HEADERS = {
    userEmail: 'Email',
    productName: 'Product',
    externalSubscriptionId: 'Product Access Term',
    startDate: 'Start Date',
    endDate: 'End Date',
    actionStatus: 'Action Status',
};
export const MODAL_WIDTH = 700;
